export default "__VITE_ASSET__CRP1SkST__"